import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  item: {
    ...dFlex('initial', 'center'),
    flex: 1,
    gap: 4,
  },
  content: {
    ...dFlex('initial', 'center'),
    gap: 8,
  },
}));

export default useStyles;
